import HeaderFooterLayout from 'layouts/HeaderFooterLayoutAdmin';
import React from 'react';
import AdminResetPassword from '../components/AdminPanel/ResetPassword';

const AdminResetPasswordPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <AdminResetPassword {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdminResetPasswordPage;
